// Builds the spoken Loom walkthrough script for a service-charge file by dropping the live
// figures into an editable wording template (Settings -> Reporting -> Loom script template).
// No AI / third-party service — pure placeholder substitution, driven by the final accounts.

const money = (n) => {
    const v = Math.round(Math.abs(Number(n) || 0));
    return `£${v.toLocaleString("en-GB", { maximumFractionDigits: 0 })}`;
};

// Values pulled straight from the computed accounts model (acc = GET /accounts response).
export function loomTokens(acc, variant = "review") {
    const isc = (acc.income_statement && acc.income_statement.consolidated) || {};
    const bs = acc.balance_sheet || {};
    const surplus = Number(isc.surplus || 0);
    const surplusPhrase =
        Math.round(surplus) === 0
            ? "a breakeven position for the year"
            : `a ${surplus < 0 ? "deficit" : "surplus"} of ${money(surplus)} for the year`;
    const noteTitles = ((acc.notes && acc.notes.list) || [])
        .map((n) => n.title || n.name)
        .filter(Boolean)
        .join(", ");
    return {
        property: acc.client_name || "the property",
        period: acc.period || "the period",
        managing_agent: acc.managing_agent || "the managing agent",
        report_name: variant === "audit" ? "Independent Auditor's Report" : "Report of Factual Findings",
        total_income: money(isc.total_income),
        total_income_prior: money(isc.total_income_prior),
        total_expenditure: money(isc.total_expenditure),
        total_expenditure_prior: money(isc.total_expenditure_prior),
        surplus_deficit: surplusPhrase,
        reserve_balance: money(bs.total_reserves),
        notes_list: noteTitles || "see the notes section",
    };
}

// Replace every {{token}} in the template with its value from the accounts.
export function fillLoomScript(template, acc, variant = "review") {
    const tok = loomTokens(acc, variant);
    let out = template || "";
    for (const [k, v] of Object.entries(tok)) {
        out = out.split(`{{${k}}}`).join(v);
    }
    return out;
}
